import React from "react";
import { Box, Divider, TextField, Typography } from "@mui/material";
import { Button } from "@mui/material";
import { AppDialog } from "./AppDialog";
import { DatePickerComponent, DatePickerWrapper } from "./AppToolbar";
import Assignation from "../models/Assignation";
import DateUtils from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/DateUtils";
import { useAssignationPauseDialog } from "../hooks/useAssignationPauseDialog";
import { Token } from "../theme";

interface Props {
  open: boolean;
  assignation?: Assignation;
  onClose: () => void;
}

export default function AssignationPauseDialog(props: Readonly<Props>) {
  const { open, assignation, onClose } = props;
  const {
    shortStartDate,
    setShortStartDate,
    shortEndDate,
    setShortEndDate,
    reason,
    setReason,
    pauses,
    isLoading,
    handleAddPause,
    handleDeletePause,
  } = useAssignationPauseDialog(open, assignation);

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Assignation Pause"
      isLoading={isLoading}
      content={
        <Box display="flex" flexDirection="column" gap="16px" minWidth="450px">
          <DatePickerWrapper style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
            <DatePickerComponent
              views="day"
              label="Start Date"
              value={shortStartDate}
              inputFormat="yyyy-MM-dd"
              onChange={(value) => setShortStartDate(value)}
            />
            <DatePickerComponent
              views="day"
              label="End Date"
              value={shortEndDate}
              inputFormat="yyyy-MM-dd"
              onChange={(value) => setShortEndDate(value)}
            />
          </DatePickerWrapper>

          <TextField label="Reason (optional)" value={reason} onChange={(event) => setReason(event.target.value)} size="small" multiline />

          <Button variant="contained" color="primary" onClick={handleAddPause}>
            Add pause
          </Button>

          <Divider />

          <Typography variant="subtitle1">Existing pauses</Typography>
          {pauses.length === 0 ? (
            <Typography variant="body2">No pauses registered.</Typography>
          ) : (
            <Box display="flex" flexDirection="column" gap="8px">
              {pauses.map((pause) => (
                <Box
                  key={pause.externalId}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  border={`1px solid ${Token.borderDefault}`}
                  borderRadius="6px"
                  padding="8px"
                >
                  <Box>
                    <Typography variant="body2">
                      {DateUtils.formatAsDDMMMYYY(new Date(pause.shortStartDate))} -{" "}
                      {DateUtils.formatAsDDMMMYYY(new Date(pause.shortEndDate))}
                    </Typography>
                    {pause.reason && <Typography variant="caption">{pause.reason}</Typography>}
                  </Box>
                  <Button size="small" color="secondary" onClick={() => handleDeletePause(pause.externalId)}>
                    Delete
                  </Button>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      }
      buttons={[
        {
          label: "Close",
          onClick: onClose,
        },
      ]}
      hideCancel
    />
  );
}
